/* eslint-disable class-methods-use-this */
import { PagedResultDto } from 'services/dto';
import { PagedRequestDto } from 'services/request';
import http from '../httpService';
import {
  ClearVehicleReminder,
  CreateUpdateVehicleReminder,
  Reminder,
  VehicleReminder,
} from './reminder';

class ReminderService {
  public async getAll(request: PagedRequestDto): Promise<PagedResultDto<Reminder>> {
    const result = await http.get('api/services/app/Reminder/GetAll', {
      params: request,
    });
    return result.data.result;
  }

  public async getVehicleReminders(vin: string): Promise<VehicleReminder[]> {
    const result = await http.get(`api/services/app/Reminder/GetVehicleReminders?vin=${vin}`);
    return result.data.result;
  }

  public async getOverdueReminderCount(vin: string): Promise<number> {
    const result = await http.get(`api/services/app/Reminder/GetOverdueReminderCount?vin=${vin}`);
    return result.data.result;
  }

  public async createOrUpdateVehicleReminder(
    request: CreateUpdateVehicleReminder
  ): Promise<VehicleReminder> {
    const result = await http.post(
      'api/services/app/Reminder/CreateOrUpdateVehicleReminder',
      request
    );
    return result.data.result;
  }

  public async clearVehicleReminder(request: ClearVehicleReminder): Promise<void> {
    await http.post('api/services/app/Reminder/ClearVehicleReminder', request);
  }
}

export default new ReminderService();
